module.exports = __webpack_public_path__ + "img/2.c715a512.png";